// extracted by mini-css-extract-plugin
export var attribution = "_ah-4";
export var authorName = "_ah-5";
export var quote = "_ah-3";
export var testimonial = "_ah-2";
export var trustedBy = "_ah-0";
export var trustedByLabel = "_ah-1";